import { Separator } from '~/components/ui'
import MapMinMaxFilter from './min-max'

type MapSaleFilterProps = {
  maxPrice?: number
  minPrice?: number
  maxCap?: number
  minCap?: number
  updateFilter: (key: string, value: any) => void
}

export default function MapSaleFilter({
  maxPrice,
  minPrice,
  maxCap,
  minCap,
  updateFilter,
}: MapSaleFilterProps) {
  return (
    <div className="space-y-2">
      <Separator />
      <p className="font-semibold">Sale</p>
      <MapMinMaxFilter
        className="!mt-2"
        minName="min_price"
        maxName="max_price"
        label="Sale Price"
        start="$"
        min={minPrice}
        max={maxPrice}
        updateFilter={updateFilter}
      />
      <MapMinMaxFilter
        minName="min_cap"
        maxName="max_cap"
        label="Cap Rate"
        end="%"
        min={minCap}
        max={maxCap}
        updateFilter={updateFilter}
      />
    </div>
  )
}
